// Types
import Regulation from '@shared/types/regulation';

const walletNavigation = [
    {
        name: 'send',
        text: 'wallet.send',
        class: 'send',
        icon: 'topup',
        color: '#1772f2',
        url: '/wallet/withdraw',
        regulationConfig: {
            [Regulation.Usa]: {
                isDisabled: true,
            },
        },
    },
    {
        name: 'receive',
        text: 'wallet.receive',
        class: 'receive',
        icon: 'transfer',
        color: '#8fc741',
        url: '/wallet/receive',
        regulationConfig: {
            [Regulation.Usa]: {
                isHidden: true,
            },
        },
    },
    {
        name: 'topup',
        text: 'wallet.topup',
        class: 'topup',
        icon: 'topup-icon',
        color: '#ffa101',
        url: '/wallet/topup',
    },
    {
        name: 'transactions',
        text: 'wallet.transactions',
        class: 'transactions',
        icon: 'trading-order-history',
        color: '#4a4a4a',
        url: '/wallet/transactions',
    },
];

export default walletNavigation;